import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{staticClass:"btn-class text--secondary",attrs:{"icon":""},on:{"click":_vm.toggleTheme}},[(_vm.$vuetify.theme.dark)?_c(VIcon,[_vm._v("mdi-white-balance-sunny")]):_c(VIcon,[_vm._v("mdi-weather-night")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }